module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-1"
    }
  }, [_vm._v("The Return of the Raven Mocker")]), _vm._v(" "), _c('p', {
    staticClass: "book-subtitle",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("An Alafair Tucker Mystery")]), _vm._v(" "), _c('p', {
    staticClass: "book-author",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Donis Casey")]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "href": "http://www.DonisCasey.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "hyperlink",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("www.DonisCasey.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "book-publisher",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Poisoned Pen Press")]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_c('img', {
    staticClass: "frame",
    attrs: {
      "alt": "33051.png",
      "src": "OEBPS/image/33051.png"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36deaf7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Return_of_the_Raven_Mocker.vue
// module id = 60
// module chunks = 0